import { FC } from 'react'
import { Box } from '@/components/atoms/Grid'
import { BridgeProduct } from 'types/bridgeProduct'
import {
  ShowProductModal,
  withProductDetailPopup
} from '@/HOC/withProductDetailPopup'
import { ListingData } from 'types/listingData'
import { ProductListingFetcher } from '@/components/organisms/productListing/productListingFetcher'
import BannersLayout, { BannersType } from './bannersLayout'
import ProductsContainerRedesign from './productsContainerRedesign'
import { HomeBanner } from '@/network/graphql.g'

type CampaignProductsContainerProps = {
  data: ListingData<BridgeProduct>
  description?: string
  showProductModal?: ShowProductModal
  productListingFetcher: ProductListingFetcher
  list: string
  useFitIn?: boolean
  showPager: boolean
  isInSaleCampaign: boolean
  isParfumCampaign: boolean
  campaignTitle: string
  campaignId: string
  isCampaignForCountDown: boolean
  categoryProductBanners: HomeBanner[]
  desktopImageUrl: string
  mobileImageUrl: string
} & Rest

const CampaignProductsContainer: FC<CampaignProductsContainerProps> = ({
  data,
  description,
  showProductModal,
  productListingFetcher,
  list,
  useFitIn = false,
  showPager,
  isInSaleCampaign,
  isParfumCampaign,
  campaignTitle,
  campaignId,
  isCampaignForCountDown,
  categoryProductBanners,
  desktopImageUrl,
  mobileImageUrl,
  ...rest
}) => {
  return (
    <Box
      textAlign="center"
      mt={{ desktop: 48 }}
      mb={50}
      flex="1"
      data-testid="productListingContainer"
      {...rest}
    >
      {data.banners && (
        <BannersLayout
          banners={data.banners}
          bannerDst={BannersType.Campaign}
          mb={{ desktop: description ? 20 : 50, tablet: 50, mobile: 20 }}
          gridColumnGap={16}
          gridRowGap={16}
          data-testid="bannersLayout"
        />
      )}
      <ProductsContainerRedesign
        fetcher={productListingFetcher}
        data={data}
        action={showProductModal}
        showPager={showPager}
        list={list}
        useFitIn={useFitIn}
        isInSaleCampaign={isInSaleCampaign}
        isParfumCampaign={isParfumCampaign}
        campaignTitle={campaignTitle}
        campaignId={campaignId}
        isCampaignForCountDown={isCampaignForCountDown}
        isCampaign={true}
        categoryProductBanners={categoryProductBanners}
        desktopImageUrl={desktopImageUrl}
        mobileImageUrl={mobileImageUrl}
      />
    </Box>
  )
}

export default withProductDetailPopup(CampaignProductsContainer)
